<template>
  <div>
    <loginHeader class="header"></loginHeader>
    <loginFooter></loginFooter>
    <div class="login_outer">
      <div class="login_wrap">
        <div class="left-bg">
          <div class="ddbes-logo"></div>
          <div class="ddbes-slogan">每一份工作&nbsp;都要有担当</div>
        </div>
        <div class="right-login">
          <div class="tab_wrap" id="switchTab">
            <div
              id="qr_title"
              @click="qr_tab"
              class="tab"
              data-type="_qrTab_"
              data-tab="_accountTab_"
            >
              扫码登录
            </div>
            <div class="tab_divider"></div>
            <div
              id="account_title"
              @click="account_tab"
              class="tab active"
              data-type="_accountTab_"
              data-tab="_qrTab_"
            >
              账号登录
            </div>
          </div>
          <!-- 账号登录 -->
          <div class="account-login" id="_accountTab_">
            <div class="form_wrap">
              <el-input
                class="input"
                id="phone_num"
                maxlength="11"
                placeholder="请输入手机号码"
                prefix-icon="el-icon-user"
                v-model="phone_num"
                clearable
                @blur="verdict_phone"
              ></el-input>
              <el-input
                class="input"
                id="_password_"
                maxlength="16"
                placeholder="6-16位字母和数字组合的密码"
                prefix-icon="el-icon-lock"
                v-model="password"
                show-password
                @blur="verdict_pwd"
              ></el-input>
            </div>
            <div class="error-text" id="_error_"></div>
            <div class="login_type">
              <div class="verification_login">
                <a @click.prevent="verification" href>验证码登录</a>
              </div>
              <div class="forget-pwd">
                <a @click.prevent="retrieve" href>找回密码</a>
              </div>
            </div>
            <div class="btn-style" id="login_button" @click="handleClickLogin">
              登录
            </div>
          </div>
          <!-- 扫码登录 -->
          <div class="qr-login" id="_qrTab_">
            <div class="qr_wrap"></div>
            <div class="refresh-qr">
              <i class="refresh-icon"></i>
              <span>刷新</span>
            </div>
            <div class="refresh-title">请使用 担当APP 或 微信 扫码登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validateTel, validatePwd } from "@/utils/validate";
import { showError, addErrorClass } from "@/utils/common";
import { loginApi } from "@/api/index.js";
import { setGstore } from "@/utils/storage";
import { Bus } from "@/utils/bus";
export default {
  components: {
    loginHeader: () =>
      import(/* webpackChunkName: "design" */ "@/components/login_header"),
    loginFooter: () =>
      import(/* webpackChunkName: "design" */ "@/components/login_footer"),
  },
  data() {
    return {
      phone_num: "",
      password: "",
      is: false,
    };
  },
  mounted() {
    this.passwordEnter();
  },
  computed: mapState(["topList", "menuList"]),
  methods: {
    qr_tab() {
      $("#_accountTab_").hide();
      $("#_qrTab_").show();
      $("#qr_title").css("color", "#2479ED");
      $("#account_title").css("color", "#999999");
    },
    account_tab() {
      $("#_accountTab_").show();
      $("#_qrTab_").hide();
      $("#account_title").css("color", "#2479ED");
      $("#qr_title").css("color", "#999999");
    },
    verdict_phone() {
      const mobile = this.phone_num;
      const password = this.password;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      } else {
        showError("");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      }
    },

    verdict_pwd() {
      const password = this.password;
      if (!validatePwd(password)) {
        showError("密码格式不正确");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      } else {
        showError("");
        addErrorClass("phone_num");
        addErrorClass("_password_", !0);
      }
    },

    //登录
    handleClickLogin() {
      const mobile = this.phone_num;
      const password = this.password;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      } else if (!validatePwd(password)) {
        showError("密码格式不正确");
        addErrorClass("phone_num");
        addErrorClass("_password_", !0);
      } else {
        showError();
        addErrorClass("phone_num");
        addErrorClass("_password_");
        $("#login_button").text("登录中...");
        $("#login_button").addClass("notclick");
        let data = {
          mobile: "86" + this.phone_num,
          password: this.password,
        };
        loginApi(data)
          .then((res) => {
            if (res.code === 0) {
              this.$message.error(res.msg);
              $("#login_button").text("登录");
              $("#login_button").removeClass("notclick");
            } else {
              setGstore("authorization", res.data.authorization);
              document.cookie = "JSESSIONID=" + res.data.jsessionId;
              setGstore("loginData", res.data);
              this.$store.state.topList = res.data.menuList;
              this.$router.push({
                path: `/first`,
              });
            }
          })
          .catch((error) => {});
      }
    },
    passwordEnter() {
      $("#_password_").on("keyup", (event) => {
        if (event.keyCode === 13) {
          this.handleClickLogin();
        }
      });
    },
    qr_code() {
      this.$router.push({
        path: `/qr_code`,
      });
    },
    retrieve() {
      this.$router.push({
        path: `/retrieve`,
      });
    },
    verification() {
      this.$router.push({
        path: `/verification`,
      });
    },
    whole() {
      this.$router.push({
        path: `/whole`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.notclick {
  pointer-events: none;
}

.login_outer {
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login_wrap {
  width: 870px;
  height: 520px;
  display: flex;
  overflow: auto;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(36, 121, 237, 0.1);
}

.left-bg {
  width: 470px;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url("../assets/login_bg.png") no-repeat center / 100%;

  .ddbes-logo {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    background: url("../assets/logo-fff@2x.png") no-repeat center / 100%;
  }

  .ddbes-slogan {
    color: #fff;
    font-size: 18px;
  }
}

.right-login {
  flex: 1;
  padding: 48px 40px 0;
}

.tab_wrap {
  display: flex;
  position: relative;
  justify-content: center;
  justify-content: space-between;
  padding: 0 84 - 40px;

  .tab {
    color: #999;
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover,
    &.active {
      color: #2479ed;
    }
  }

  .tab_divider {
    width: 1px;
    height: 16px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: #bdc1c9;
  }
}

.account-login,
.qr-login {
  margin-top: 55px;
}

.form_wrap {
  .input {
    height: 48px;

    &:first-child {
      margin-bottom: 20px;
    }
  }
}

.error-text {
  color: #ff0000;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.login_type {
  display: flex;
}

.verification_login {
  text-align: left;
  margin-bottom: 20px;
  flex: 1;

  > a {
    color: #323232;
    font-size: 14px;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #2479ed;
    }
  }
}

.forget-pwd {
  text-align: right;
  margin-bottom: 20px;

  > a {
    color: #323232;
    font-size: 14px;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #2479ed;
    }
  }
}

.btn-style {
  color: #ffffff;
  font-size: 16px;
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  transition: background-color 0.3s;
  background-color: lighten(#2479ed, 10%);

  &:hover {
    cursor: pointer;
    background-color: #2479ed;
  }
}

.qr-login {
  display: none;

  .qr_wrap {
    width: 200px;
    height: 200px;
    padding: 18px;
    margin: auto;
    border-radius: 4px;
    border: 1px solid #bdc1c9;
  }

  .refresh-qr {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 13px auto 25px;

    > span {
      color: #999;
      font-size: 14px;
    }

    .refresh-icon {
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../assets/refresh@2x.png") no-repeat center / 100%;
    }
  }

  .refresh-title {
    color: #323232;
    font-size: 14px;
    text-align: center;
    margin-top: 25px;
  }
}
</style>
